import { Component, OnInit } from '@angular/core';
import { CfetBaseComponent, CfetService, CfetPageNamesConstant } from '../../cfet-core';
import { environment } from '../../../environments/environment';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-utf-sync-info-page',
    templateUrl: './utf-sync-info-page.component.html',
    styleUrls: ['./utf-sync-info-page.component.scss'],
    standalone: false
})
export class UtfSyncInfoPageComponent extends CfetBaseComponent implements OnInit {
  httpHeaders: any = {};
  amContactEmail: any;
  amEmailVerified: any;
  amFirstName: any;
  amLastName: any;
  amdbat: any;
  validEmail: any;
  amUserId: any;
  showSingleIdPage: any;
  returnUrl = '';

  constructor(private cfetService: CfetService, private activatedRoute: ActivatedRoute) {
    super();
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params && params['returnURL']) {
        this.returnUrl = this.sanitizeReturnUrl(params['returnURL']);
      }
      if (this.returnUrl.length !== 0) {
        sessionStorage.setItem('returnUrl', JSON.stringify(this.returnUrl));
      }
    });
    this.cfetService.utfHeader().subscribe((response: any) => {
      this.httpHeaders = response;
      sessionStorage.removeItem('ngStorage-affCode');
      if (sessionStorage.getItem('ngStorage-AMUTFHeaders') &&
        Object.keys(sessionStorage.getItem('ngStorage-AMUTFHeaders')).length !== 0) {
        // Save the Headers from AM
        this.saveHeadersFromAm();
        // Authenticated flow - Single IDs or Separate IDs; Check if it's UTF compatible Email format or not
        if (this.amUserId && this.amUserId !== '') {
          const emailRegex = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/);
          this.validEmail = emailRegex.test(this.amUserId);
          this.showSingleIdPage = false;
          sessionStorage.setItem('showSingleIdPage', JSON.stringify(this.showSingleIdPage));
          window.location.href = environment.signup_domain +
            CfetPageNamesConstant.UTF_AUTH_SINGLE_ID_PAGE + '?firstname=' + this.amFirstName + '&lastname=' + this.amLastName +
            '&email=' + this.amContactEmail + '&isEmailVerified=' + this.amEmailVerified + '&userid=' + this.amUserId + '&accessToken=' + this.amdbat;
        } else {
          // No email format UTF compatible
          this.showSingleIdPage = true;
          sessionStorage.setItem('showSingleIdPage', JSON.stringify(this.showSingleIdPage));
          window.location.href = environment.signup_domain + CfetPageNamesConstant.UTF_AUTH_SINGLE_ID_PAGE;
        }
      }
      localStorage.setItem('httpHeaders', JSON.stringify(this.httpHeaders));
    });
  }

  saveHeadersFromAm() {
    this.httpHeaders = JSON.parse(sessionStorage.getItem('ngStorage-AMUTFHeaders'));
    this.amUserId = this.httpHeaders['xuserid'] ? this.httpHeaders['xuserid'] : '';
    this.amContactEmail = this.httpHeaders['xcontactemail'] ? this.httpHeaders['xcontactemail'] : '';
    this.amEmailVerified = this.httpHeaders['xemailverified'] ? this.httpHeaders['xemailverified'] : '';
    this.amFirstName = this.httpHeaders['xfirstname'] ? this.httpHeaders['xfirstname'] : '';
    this.amLastName = this.httpHeaders['xlastname'] ? this.httpHeaders['xlastname'] : '';
    this.amdbat = this.httpHeaders['xaccesstoken'] ? this.httpHeaders['xaccesstoken'] : '';
  }

  private sanitizeReturnUrl(rawUrl: any): string {
    if (!rawUrl || typeof rawUrl !== 'string') {
      return '';
    }
    try {
      const parsed = new URL(rawUrl, window.location.origin);
      const allowedOrigins = [window.location.origin, environment.signup_domain];
      if (!/^https?:$/i.test(parsed.protocol) || allowedOrigins.indexOf(parsed.origin) === -1) {
        return '';
      }
      if (parsed.origin === window.location.origin) {
        return parsed.pathname + parsed.search + parsed.hash;
      }
      return parsed.toString();
    } catch (e) {
      return '';
    }
  }
}
